import React, { Component } from 'react'

import Percentage from '../Percentage'

import './index.scss'


class GaugeChart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      progressLine: -339,
      prevValue: 0,
    }
  }

  componentDidUpdate() {
    if (this.props.value !== this.state.prevValue) {
      this.animateProgress(this.props.value, this.props.maxValue)
    }
  }

  componentDidMount() {
    this.animateProgress(this.props.value, this.props.maxValue)
  }

  animateProgress(value, maxValue) {
    const progressLine = this.calcProgress(value, maxValue)
    this.setState({ ...this.state, progressLine, prevValue: value })
  }

  calcProgress(value, maxValue) {
    // 339 -> 0
    const maxProgress = 339
    let total = (value * maxProgress) / maxValue
    total = total - maxProgress
    if (value <= 0) total = -maxProgress
    if (value >= maxValue) total = 0
    return total
  }

  render() {
    const { value, maxValue, type } = this.props
    return (
      <div className="gauge-chart">
        <div className="gauge-chart__center">
          <Percentage value={value} maxValue={maxValue} />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="246.079"
            height="122.693"
            viewBox="0 0 246.079 122.693"
          >
            <g id="Grupo_42" data-name="Grupo 42" transform="translate(15 15.002)">
              <defs>
                <linearGradient id="gradient--success" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#FFF3F3" />
                  <stop offset="100%" stopColor="#FF7D69" />
                </linearGradient>
                <linearGradient id="gradient--possible" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#FFE5A6" />
                  <stop offset="100%" stopColor="#FAC74C" />
                </linearGradient>
                <linearGradient id="gradient--failed" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#26A69A" />
                  <stop offset="100%" stopColor="#26A69A" />
                </linearGradient>
              </defs>
              <path
                d="M223.579,74.39A107.96,107.96,0,0,0,14.11,37.9,105.644,105.644,0,0,0,7.5,74.224"
                transform="translate(-7.5 33.301)"
                fill="none"
                stroke="#f6f6f6"
                strokeLinejoin="round"
                strokeWidth="30"
              />
              <path
                className={(type === 2) ? "" : "hidden"}
                d="M223.579,74.39A107.96,107.96,0,0,0,14.11,37.9,105.644,105.644,0,0,0,7.5,74.224"
                transform="translate(-7.5 33.301)"
                fill="none"
                stroke="url(#gradient--success)"
                strokeLinejoin="round"
                strokeWidth="30"
                strokeDasharray="339"
                strokeDashoffset={this.state.progressLine}
              />
              <path
                className={(type === 1) ? "" : "hidden"}
                d="M223.579,74.39A107.96,107.96,0,0,0,14.11,37.9,105.644,105.644,0,0,0,7.5,74.224"
                transform="translate(-7.5 33.301)"
                fill="none"
                stroke="url(#gradient--possible)"
                strokeLinejoin="round"
                strokeWidth="30"
                strokeDasharray="339"
                strokeDashoffset={this.state.progressLine}
              />
              <path
                className={(type === 0) ? "" : "hidden"}
                d="M223.579,74.39A107.96,107.96,0,0,0,14.11,37.9,105.644,105.644,0,0,0,7.5,74.224"
                transform="translate(-7.5 33.301)"
                stroke="url(#gradient--failed)"
                fill="none"
                strokeLinejoin="round"
                strokeWidth="30"
                strokeDasharray="339"
                strokeDashoffset={this.state.progressLine}
              />
            </g>
          </svg>
        </div>
      </div>
    )
  }
}

export default GaugeChart
